import { render, staticRenderFns } from "./Setup_EMDTypeEdit.vue?vue&type=template&id=cbba1fac&"
import script from "./Setup_EMDTypeEdit.vue?vue&type=script&lang=js&"
export * from "./Setup_EMDTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports